var path = 'areas/projects/views/azure_powershell_script_info.html';
var html = "<div class=\"alert alert-info form-group-narrow\"> <p> <span ng-show=\"action.ActionType !== 'Octopus.AzurePowerShell'\">If you are running a PowerShell script as part of this step</span> <span ng-show=\"action.ActionType === 'Octopus.AzurePowerShell'\">As this step is running a PowerShell script</span> the <a class=alert-link target=_blank href=https://g.octopushq.com/WindowsManagementFramework3Download>Windows Management Framework 3</a> (or newer) must be installed on the <strong>Octopus Server</strong>. </p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/azure_powershell_script_info.html
// module id = 924
// module chunks = 1